import React, { createContext, useState } from 'react';

export const LeftSection = createContext();

const LeftSectionContextProvider = (props) => {
    const [showLeft, setShowLeft] = useState({ air: true, lumpsetting: false, lumpRGB: false, time: false, threeWay: false, parking: false, map: false, music: false, camera: false, gallery: false, keyLamp: false });

    const show = (action) => {
        switch (action) {
            case "air":
                setShowLeft({ air: true, lumpsetting: false, lumpRGB: false, time: false, threeWay: false, parking: false, map: false, music: false, camera: false, gallery: false, keyLamp: false })
                break;
            case "edit":
                setShowLeft({ air: false, edit: true, lumpsetting: false, lumpRGB: false, time: false, threeWay: false, parking: false, map: false, music: false, camera: false, gallery: false, keyLamp: false })
                break;
            case "lumpsetting":
                setShowLeft({ air: false, lumpsetting: true, lumpRGB: false, time: false, threeWay: false, parking: false, map: false, music: false, camera: false, gallery: false, keyLamp: false })
                break;
            case "lumpRGB":
                setShowLeft({ air: false, lumpsetting: false, lumpRGB: true, time: false, threeWay: false, parking: false, map: false, music: false, camera: false, gallery: false, keyLamp: false })
                break;
            case "time":
                setShowLeft({ air: false, lumpsetting: false, lumpRGB: false, time: true, threeWay: false, parking: false, map: false, music: false, camera: false, gallery: false, keyLamp: false })
                break;
            case "threeWay":
                setShowLeft({ air: false, lumpsetting: false, lumpRGB: false, time: false, threeWay: true, parking: false, map: false, music: false, camera: false, gallery: false, keyLamp: false })
                break;
            case "parking":
                setShowLeft({ air: false, lumpsetting: false, lumpRGB: false, time: false, threeWay: false, parking: true, map: false, music: false, camera: false, gallery: false, keyLamp: false })
                break;
            case "map":
                setShowLeft({ air: false, lumpsetting: false, lumpRGB: false, time: false, threeWay: false, parking: false, map: true, music: false, camera: false, gallery: false, keyLamp: false })
                break;
            case "music":
                setShowLeft({ air: false, lumpsetting: false, lumpRGB: false, time: false, threeWay: false, parking: false, map: false, music: true, camera: false, gallery: false, keyLamp: false })
                break;
            case "camera":
                setShowLeft({ air: false, lumpsetting: false, lumpRGB: false, time: false, threeWay: false, parking: false, map: false, music: false, camera: true, gallery: false, keyLamp: false })
                break;
            case "gallery":
                setShowLeft({ air: false, lumpsetting: false, lumpRGB: false, time: false, threeWay: false, parking: false, map: false, music: false, camera: false, gallery: true, keyLamp: false })
                break;
            case "keyLamp":
                setShowLeft({ air: false, lumpsetting: false, lumpRGB: false, time: false, threeWay: false, parking: false, map: false, music: false, camera: false, gallery: false, keyLamp: true })
                break;
        }
    }

    return (
        <>
            <LeftSection.Provider value={{ showLeft, show }}>
                {props.children}
            </LeftSection.Provider>
        </>
    );
};

export { LeftSectionContextProvider };